import { DateTime } from 'luxon';

export class PopupMenuItem
{
    id: string;
    order: number;
    separator: boolean = false;
    key: string;
    icon: string;
    enabled: boolean = true;
    cta?: (event?: any) => any;
    link?: string;
    active: boolean;
    production: DateTime;
    staging: DateTime;
    danger: boolean = false;
    isHrefLink: boolean = false;
}
